import { render, staticRenderFns } from "./Effectiveness.vue?vue&type=template&id=afb318d2"
import script from "./Effectiveness.vue?vue&type=script&lang=js"
export * from "./Effectiveness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports